import { Link } from "react-router-dom";
import type { Subtitle } from "@/mocks/subtitles";
import { formatDownloads } from "@/utils/subtitles";

const typeColorMap: Record<string, string> = {
  movie: "bg-primary-100 text-primary-700",
  tv: "bg-accent-100 text-accent-800",
  variety: "bg-secondary-100 text-secondary-900",
  anime: "bg-primary-100 text-primary-700",
};

interface SubtitleCardProps {
  item: Subtitle;
}

export default function SubtitleCard({ item }: SubtitleCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title}（${item.year}）${item.language}中文字幕封面`}
          title={`${item.title} 中文字幕 - ${item.format.toUpperCase()}`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-2 top-2 rounded-md px-2 py-0.5 text-[11px] font-medium ${
            typeColorMap[item.typeSlug] ?? "bg-primary-100 text-primary-700"
          }`}
        >
          {item.type}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] font-semibold uppercase text-background-50">
          {item.format}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950" title={item.title}>
          {item.title}
        </h3>
        <p className="truncate text-xs text-foreground-500">{item.originalTitle}</p>
        <div className="mt-auto flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{item.year}</span>
          <span className="text-background-400">·</span>
          <span>{item.language}</span>
        </div>
        <div className="flex items-center justify-between border-t border-background-200 pt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-download-2-line text-sm text-secondary-600"></i>
            {formatDownloads(item.downloads)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-sm text-accent-500"></i>
            {item.rating.toFixed(1)}
          </span>
        </div>
      </div>
    </Link>
  );
}